// LanguageToggle.js
import { useLocation, useNavigate } from "react-router-dom";

const LanguageToggle = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isSpanish =
    location.pathname === "/" || location.pathname.startsWith("/es");

  const switchLanguage = () => {
    const isSpanish =
      location.pathname.startsWith("/es") || location.pathname === "/";
    const pathWithoutLang = location.pathname.replace(/^\/(es|en)/, "") || "";
    const normalizedPath = pathWithoutLang.startsWith("/")
      ? pathWithoutLang
      : `/${pathWithoutLang}`;
    const newPath = isSpanish ? `/en${normalizedPath}` : `/es${normalizedPath}`;
    navigate(newPath + location.search);
  };

  return (
    <button
      onClick={switchLanguage}
      style={{
        position: "fixed",
        top: "16px",
        right: "16px",
        background: "#ffffff",
        border: "2px solid #007b94",
        color: "#007b94",
        fontWeight: "bold",
        borderRadius: "6px",
        padding: "6px 12px",
        fontSize: "14px",
        cursor: "pointer",
        zIndex: 1000,
      }}
    >
      {isSpanish ? "EN" : "ES"}
    </button>
  );
};

export default LanguageToggle;
